// extracted by mini-css-extract-plugin
export var errorIcon = "_ow-1";
export var nameLogo = "_ow-0";